
import { Component, Prop, Vue } from "vue-property-decorator";
import { IMovementsReport } from "@/modules/Report/Movements/interfaces/movements-report.interface";
import { IAuth } from "@/modules/Auth/interfaces/auth.interface";
import { openMediaPopup } from "@/modules/Report/Movements/helpers/open-media-popup";
import { IProfilePayment } from "@/modules/Profile/interfaces/profile-payment.interface";
import { httpResource } from "@/resources/http.resource";
import {isMobile} from "mobile-device-detect";

@Component({})
export default class ActionsDropdown extends Vue {
  @Prop() entity: IMovementsReport.IDataItem;
  @Prop() index: number;
  @Prop() tableList: IMovementsReport.IDataItem[];
  @Prop() fromCarPopup!: boolean;
  @Prop() fromSelectMovePopup!: boolean;

  get userAccess(): IAuth.UserAccess { return this.$store.state.auth.userAccess; }
  get displayDecodeMoney() { return this.entity.movId && this.userAccess.scSumInfoFlag; }
  get displayGetCheck() { return this.entity.movId && this.entity.bankPayFlag && this.userAccess.scFiscalLink; }
  get displayEditSubmenu() { return this.fromCarPopup && this.entity.movId; }
  get displayDropdownBtn() { return this.entity.movId && this.dropdownActions.some(action => action.display); }

  get dropdownActions() {
    return [
      {
        label: 'Изменить',
        display: !!(this.entity.movId && this.userAccess.scMovMk && isMobile),
        action: this.openChangeDialog,
        mobileOnly: true,
      },
      {
        label: 'Просмотр фото',
        display: !!(this.entity.movId && this.entity.hasPhoto && isMobile),
        action: this.openMediaPopup,
        mobileOnly: true,
      },
      {
        label: 'Изменить',
        display: this.displayEditSubmenu,
        action: this.openChangeDialog,
        mobileOnly: false,
      },
      {
        label: 'Расшифровка суммы',
        display: this.displayDecodeMoney,
        action: this.decodeMoney,
        mobileOnly: false,
      },
      {
        label: 'Показать фискальный чек',
        display: this.displayGetCheck,
        action: this.openCheckPage,
        mobileOnly: false,
      },
    ];
  }

  async dropdownHandle(dropdownItem: any) {
    await dropdownItem.action();
    await this.afterAction();
  }

  async openMediaPopup() {
    const payload = {
      item: this.entity,
      index: this.index,
      tableList: this.tableList,
      fromCarPopup: this.fromCarPopup || this.fromSelectMovePopup,
    };
    await openMediaPopup(payload);
  }

  async openChangeDialog() {
    await this.$store.dispatch('report/openChangeDialog', {
      entity: this.entity,
      fromCarPopup: this.fromCarPopup,
      fromSelectMovePopup: this.fromSelectMovePopup,
    });
  }

  async decodeMoney() {
    await this.$store.dispatch('dialog/openDialog', {
      blockName: 'allPages',
      dialogName: 'decodeMoneyPopup',
      payload: {
        movId: this.entity.movId,
        carNumber: this.entity.carNumber,
      },
    });
  }

  async openCheckPage() {
    const asyncAction = async () => {
      const action = IProfilePayment.Action.BankCards;
      const params: any = {
        command: IProfilePayment.Command.GetCheck,
        movId: this.entity.movId,
      };

      const { data: { result: { fiscalLink } } } = await httpResource.httpAction({ action, params });
      if (fiscalLink) window.open(fiscalLink, '_blank');
    };

    return await this.$store.dispatch('defaultResourceAction', { asyncAction });
  }

  async afterAction() {
    if (this.fromSelectMovePopup) {
      await this.$store.dispatch('dialog/closeDialog', {
        blockName: 'reports',
        dialogName: 'selectMovementPopup',
      });
    }
  }
}
